<div class="weather-info-tab">
<div class="info-content">
  <div class="info-header">
    <div class="date-info">
      <span class="label">{{ 'DATE' | translate }}</span>
      <app-date-picker
        [(ngModel)]="date"
        [placeholder]="'Select Date' | translate"
        [showIcon]="true"
        [showClear]="false"
        [dateFormat]="'dd.mm.yy'"
        [dateOnly]="true"
        (ngModelChange)="loadWeatherInfo()"
      ></app-date-picker>
      <!--      <span class="value">{{ weatherInfo?.date | dateFormatLang:translate.currentLang }}</span>-->
    </div>
    <div class="provider-info">
      <div class="control-group">
        <msf-select
          [(model)]="selectedDataSource"
          (selectItem)="onDataSourceChange()"
          [options]="dataSourceOptions"
          [optionValue]="'id'"
          [width]="'100%'"
        ></msf-select>
      </div>
    </div>
  </div>

  <div class="interpolation-note">
    <app-checkbox
      [(ngModel)]="interpolationEnabled"
      (ngModelChange)="onInterpolationChange()"
      [label]="'INTERPOLATION'"
      [size]="'medium'"
    ></app-checkbox>
  </div>

  <!-- No data message -->
  @if (!isLoading && !weatherInfo) {
    <div class="no-forecast-data">
      <div class="no-data-message">
        <i class="pi pi-info-circle"></i>
        <span>{{ 'NO_WEATHER_DATA_AVAILABLE' | translate }}</span>
      </div>
    </div>
  }

  <!-- Norms unavailable message when interpolation is enabled -->
  @if (!isLoading && weatherInfo && interpolationEnabled && (selectedDataSource === 'era5' || selectedDataSource === 'ibm') && !hasNorms) {
    <div class="norms-unavailable-message">
      <div class="no-data-message">
        <i class="pi pi-info-circle"></i>
        <span>{{ getTranslatedString('NORMS_UNAVAILABLE_FOR_INTERPOLATION', 'Нормативные значения для данной точки недоступны (интерполяция)') }}</span>
      </div>
    </div>
  }

  @if (weatherInfo) {
    <div class="weather-data-section">
      <div class="weather-data-grid col-9">
        <div class="weather-item">
          <div class="weather-item-header">
            <h4>{{ 'PRECIPITATION' | translate }}</h4>
            @if ((selectedDataSource === 'era5' || selectedDataSource === 'ibm') && weatherInfo.normFallout && weatherInfo?.precipitationLevel) {
              <img
                [src]="getLevelIcon(weatherInfo?.precipitationLevel)"
                class="status-icon" alt="Précipitation"
              >
            }
          </div>
          <div class="value-display">
            @if (!isLoading) {
              <span class="main-value">
                {{ weatherInfo?.precipitation !== null ? weatherInfo!.precipitation!.toFixed(1) : '—' }}
              </span>
            } @else {
              <span class="main-value">...</span>
            }
            <span class="unit">{{ 'gis.unit.mm' | translate }}</span>
          </div>
          <div class="details">
            <p>
              <b>x̄:</b> {{ weatherInfo.normFallout || '—' }} {{ 'gis.unit.mm' | translate }}
            </p>
            @if (weatherInfo.sumOfFallout) {
              <p class="mt-1">
                <b>Σ </b>: {{ weatherInfo.sumOfFallout }}
                <span class="unit">{{ 'gis.unit.mm' | translate }}</span>
              </p>
            }
          </div>
        </div>

        <div class="weather-item">
          <div class="weather-item-header">
            <h4>{{ 'TEMPERATURE' | translate }}</h4>
            @if ((selectedDataSource === 'era5' || selectedDataSource === 'ibm') && weatherInfo.normTemperatureAverage && weatherInfo?.temperatureLevel) {
              <img
                [src]="getLevelIcon(weatherInfo?.temperatureLevel)"
                class="status-icon" alt="Température"
              >
            }
          </div>
          <div class="value-display">
            @if (!isLoading) {
              <span class="main-value">
                {{ weatherInfo?.temperature !== null ? (weatherInfo!.temperature! > 0 ? '+' : '') + weatherInfo!.temperature!.toFixed(1) : '—' }}
              </span>
            } @else {
              <span class="main-value">...</span>
            }
            <span class="unit">°С</span>
          </div>
          <div class="details">
            <p>
              <b>x̄:</b> {{ weatherInfo.normTemperatureAverage || '—' }} °С
            </p>

            @if (weatherInfo.sumOfActiveTemperaturesBase5 || weatherInfo.sumOfActiveTemperaturesBase15 || weatherInfo.sumOfActiveTemperaturesBase10 || weatherInfo.sumOfActiveTemperaturesBase12) {
              <p class="mt-1">
                <b>Σ </b> :
                @if (weatherInfo.sumOfActiveTemperaturesBase5) {
                  <span><b>5</b>:{{ weatherInfo.sumOfActiveTemperaturesBase5 }} °С; </span>
                }
                @if (weatherInfo.sumOfActiveTemperaturesBase10) {
                  <span><b>10</b>:{{ weatherInfo.sumOfActiveTemperaturesBase10 }} °С; </span>
                }
                @if (weatherInfo.sumOfActiveTemperaturesBase12) {
                  <span><b>12</b>:{{ weatherInfo.sumOfActiveTemperaturesBase12 }} °С; </span>
                }
                @if (weatherInfo.sumOfActiveTemperaturesBase15) {
                  <span><b>15</b>:{{ weatherInfo.sumOfActiveTemperaturesBase15 }} °С; </span>
                }
              </p>
            }

            @if (!isLoading) {
              <p class="mt-1">
                {{ 'TODAY' | translate }} :
                <b>{{ 'gis.unit.min' | translate }}</b> {{ weatherInfo?.temperatureMin !== null ? weatherInfo!.temperatureMin!.toFixed(1) : '-' }}
                °С
                ;
                <b>{{ 'gis.unit.max' | translate }}</b> {{ weatherInfo?.temperatureMax !== null ? weatherInfo!.temperatureMax!.toFixed(1) : '—' }}
                °С;
              </p>
            } @else {
              <p>{{ 'gis.temperature.loading.data' | translate }}</p>
            }
          </div>
        </div>

        <div class="weather-item">
          <div class="weather-item-header">
            <h4>{{ 'solarRadiation' | translate }}</h4>
            @if ((selectedDataSource === 'era5' || selectedDataSource === 'ibm') && weatherInfo.normSolarRadiationInfluence && weatherInfo?.solarRadiationLevel) {
              <img
                [src]="getLevelIcon(weatherInfo?.solarRadiationLevel)"
                class="status-icon" alt="Rayonnement solaire">
            }
          </div>
          <div class="value-display">
            @if (!isLoading) {
              <span class="main-value">
                {{ weatherInfo?.solarRadiation !== null ? weatherInfo!.solarRadiation : '—' }}
              </span>
            } @else {
              <span class="main-value">...</span>
            }
            <span class="unit">{{ 'gis.unit.kcal' | translate }}</span>
          </div>

          <div class="details">
            <p>
              <b>x̄:</b> {{ weatherInfo.normSolarRadiationInfluence || '—' }} {{ 'gis.unit.kcal' | translate }}
            </p>
            @if (weatherInfo.sumOfSolarRadiation) {
              <p class="mt-1">
                <b>Σ </b> : {{ weatherInfo.sumOfSolarRadiation }}
                <span class="unit">{{ 'gis.unit.kcal' | translate }}</span>
              </p>
            }
          </div>
        </div>

        <div class="weather-item">
          <div class="weather-item-header">
            <h4>{{ 'HUMIDITY' | translate }}</h4>
            @if ((selectedDataSource === 'era5' || selectedDataSource === 'ibm') && weatherInfo.normHumidity && weatherInfo?.humidityLevel) {
              <img
                [src]="getLevelIcon(weatherInfo?.humidityLevel)"
                class="status-icon" alt="Humidity"
              >
            }
          </div>
          <div class="value-display">
            @if (!isLoading) {
              <span class="main-value">
                {{ weatherInfo?.humidity !== null ? (weatherInfo!.humidity! | number:'1.0-0') : '—' }}
              </span>
            } @else {
              <span class="main-value">...</span>
            }
            <span class="unit">%</span>
          </div>
          <div class="details">
            <p>
              <b>x̄:</b> {{ weatherInfo.normHumidity || '—' }} %
            </p>

            @if (isLoading) {
              <p>{{ 'gis.temperature.loading.data' | translate }}</p>
            }
          </div>
        </div>

        <div class="weather-item">
          <div class="weather-item-header">
            <h4>{{ 'WIND_SPEED' | translate }}</h4>
            @if ((selectedDataSource === 'era5' || selectedDataSource === 'ibm') && weatherInfo.normWindSpeed && weatherInfo?.windSpeedLevel) {
              <img
                [src]="getLevelIcon(weatherInfo?.windSpeedLevel)"
                class="status-icon" alt="Wind Speed"
              >
            }
          </div>
          <div class="value-display">
            @if (!isLoading) {
              <span class="main-value">
                {{ weatherInfo?.windSpeed !== null ? (weatherInfo!.windSpeed! | number:'1.1-2') : '—' }}
              </span>
            } @else {
              <span class="main-value">...</span>
            }
            <span class="unit">{{ 'gis.unit.ms' | translate }}</span>
          </div>
          <div class="details">
            <p>
              <b>x̄:</b> {{ weatherInfo.normWindSpeed || '—' }} {{ 'gis.unit.ms' | translate }}
            </p>
          </div>
        </div>

        <div class="weather-item">
          <h4>{{ 'WIND_DIRECTION' | translate }}</h4>
          <div class="value-display">
            @if (!isLoading) {
              <i class="pi pi-arrow-up wind-direction"
                 [style.transform]="getWindArrowRotation(weatherInfo?.windDirection)"
                 [title]="weatherInfo?.windDirection ? weatherInfo!.windDirection + '°' : ''"></i>
              <span
                class="main-value">{{ (getCardinalDirection(weatherInfo?.windDirection || 0) | translate) || '—' }}</span>
            } @else {
              <span class="main-value">...</span>
            }
          </div>
        </div>
      </div>

      <!-- Legend positioned next to weather data -->
      <div class="legend-inline col-3 pl-5">
        <!-- Info message about norms on Graph tab -->
        @if ((selectedDataSource === 'era5' || selectedDataSource === 'ibm') && hasNorms) {
          <div class="norms-info-message mb-3">
            <div class="info-message-box">
              <i class="pi pi-info-circle"></i>
              <span class="info-text">
                {{ getTranslatedString('NORMS_AND_DYNAMICS_ON_GRAPH_TAB', 'Нормы и годовая динамика показаны на вкладке «График»') }}
              </span>
            </div>
          </div>
        }

        <div class="legend-item normal">
          <img [src]="getWeatherIconPath('norm-point')" class="legend-icon" alt="Норма">
          <span>{{ 'NORMAL' | translate }}</span>
        </div>
        <div class="legend-item below">
          <img [src]="getWeatherIconPath('sun-lights')" class="legend-icon" alt="Ниже нормы">
          <span>{{ 'BELOW_NORMAL' | translate }}</span>
        </div>
        <div class="legend-item above">
          <img [src]="getWeatherIconPath('stop')" class="legend-icon" alt="Выше нормы">
          <span>{{ 'ABOVE_NORMAL' | translate }}</span>
        </div>

        <div class="details ml-1 m-2 flex flex-column">
          <h4> {{ 'Base temperatures' | translate }}</h4>
          <p>
            <b>5</b> °С: {{ 'Wheat' | translate }}
          </p>

          <p>
            <b> 10</b> °С: {{ 'Cotton' | translate }}, {{ 'Rice' | translate }}
          </p>

          <p>
            <b> 12</b> °С:
            {{ 'Beans' | translate }},
            {{ 'Peppers' | translate }},<br>
            {{ 'Cucumbers' | translate }},
            {{ 'Pomegranates' | translate }}
          </p>
          <p>
            <b> 15</b> °С: {{ 'Others' | translate }}
          </p>


        </div>
      </div>
    </div>
  }
  @if (isLoading) {
    <div class="loading-overlay" aria-label="loading">
      <div class="spinner"></div>
    </div>
  }
</div>
</div>
